<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fal fa-user" id="ico"></i>
		<h1 style="display: inline-block;">{{activo.descripcion}}</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row">
			<div class="col col-sm-12 col-md-7 col-lg-7 contenido">
				<i style="margin-right: 3px;"
					class="fal fa-user col-md-1"></i><b>Cliente:</b>&nbsp;<span>{{activo.cliente}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-money-check-edit col-md-1"></i><b>Descripción:</b>&nbsp;<span>{{activo.descripcion}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-barcode-scan col-md-1"></i><b>IMEI:</b>&nbsp;<span>{{activo.imei}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-barcode-read col-md-1"></i><b>Económico:</b>&nbsp;<span>{{activo.economico}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-barcode-alt col-md-1"></i><b>Serie:</b>&nbsp;<span>{{activo.numeroSerie}}</span><br>
				<div class="row" style="margin: 0; max-height: 20px;">
					<i style="margin-right: 3px;" class="fal fa-location mt-1 col-md-1"></i><b>GPS:</b>&nbsp;
					<span *ngIf="activo.gps === 'Buena'" class="verde">{{activo.gps}}</span><br>
					<span *ngIf="activo.gps === 'Media'" class="naranja">{{activo.gps}}</span><br>
					<span *ngIf="activo.gps === 'Mala'" class="rojo">{{activo.gps}}</span><br>
				</div>
				<i style="margin-right: 3px;"
					class="fal fa-satellite-dish col-md-1"></i><b>GSM:</b>&nbsp;<span>{{activo.gsm}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-signal-stream col-md-1"></i><b>Modelo:</b>&nbsp;<span>{{activo.modelo}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-battery-three-quarters col-md-1"></i><b>Bateria:</b>&nbsp;<span>{{activo.bateria}}</span><br>
				<i style="margin-right: 3px;"
					class="fal fa-power-off col-md-1"></i><b>Estatus:</b>&nbsp;<span>{{activo.estatus}}</span><br>
				<i style="margin-right: 3px;" class="fal fa-draw-polygon col-md-1"></i><b>Geocerca:</b>
				{{geocercaAsignada}}<br>
				<i style="margin-right: 3px;" class="fal fa-clock col-md-1"></i><b>Fecha y
					Hora:</b>&nbsp;<span>{{fechaHora}}</span><br>
				<i style="margin-right: 3px;" class="fal fa-location-arrow col-md-1"></i><b>Última
					Posición:</b>&nbsp;<span>[{{activo.lat
					|
					number: '1.1-4'}},
					{{activo.lng | number: '1.1-4'}}]</span><br>
				<i class="fal fa-map-pin col-md-1"></i><b>Dirección:</b>&nbsp;<span>{{direccion}}</span>
			</div>
			<div *ngIf="imagen !== null" class="col col-sm-12 col-md-5 col-lg-5 contenido">
				<img [src]="imagen" style="width: 100%;" loading="lazy">
			</div>
		</div>
		<div class="row">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button class="btnPopup ubicar mt-3" mat-raised-button (click)="ubicarActivo()"><i id="btnIco"
						class="fal fa-binoculars"></i>&nbsp;Ubicar</button>&nbsp;
				<button class="btnPopup historico mt-3" mat-raised-button (click)="verHistorico()"><i id="btnIco"
						class="fal fa-calendar-alt"></i>&nbsp;Histórico</button>&nbsp;
				<button class="btnPopup streetView mt-3" mat-raised-button (click)="verStreet()"><i id="btnIco"
						class="fal fa-street-view"></i>&nbsp;Street View</button>&nbsp;
			</div>
		</div>
	</div>
</div>
